import {makeStyles} from "@material-ui/core";

export const useStyles = makeStyles((theme) => ({
    modal: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    paper: {
        backgroundColor: theme.palette.background.paper,
        borderRadius: "5px",
        padding: theme.spacing(2, 4, 3),
        minWidth: "550px"
    },
    answersButton: {
        'color': "var(--color-red)",
        borderColor: "var(--color-red)",
        'min-width': "280px",
        '&:hover': {
            background: "var(--color-red-transparent-hover)",
        },
    },
    addAnswerButton: {
        width: "100%",
        'color': "var(--resources-primary)",
        borderColor: "var(--resources-primary)"
    }
}));